import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { STATS } from "@/data/content";

function useCountUp(target, run, duration = 1600) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!run) return;
    let raf;
    const start = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [run, target, duration]);
  return n;
}

function StatItem({ s, run, idx }) {
  const value = useCountUp(s.value, run);
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={run ? { opacity: 1, y: 0 } : {}}
      transition={{ delay: idx * 0.08, duration: 0.5 }}
      className="text-center px-4"
      data-testid={`stat-${idx}`}
    >
      <div className="font-display text-4xl md:text-5xl font-extrabold text-[#0A3161] tabular-nums">
        {value.toLocaleString()}
        <span className="text-[#B31942]">{s.suffix}</span>
      </div>
      <div className="mt-2 text-sm md:text-[15px] font-medium text-slate-600">{s.label}</div>
    </motion.div>
  );
}

export default function Stats() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  return (
    <section ref={ref} data-testid="stats-section" className="relative py-10 md:py-14 border-y border-black/5 bg-[#F8F9FA]">
      <div className="container-x">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {STATS.map((s, i) => (
            <StatItem key={s.label} s={s} run={inView} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
